module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-three.9db6b711.png";